// @flow
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import classNames from 'classnames';
import type { Node } from 'react';

type Props = {
  // TODO: decouple href and disabled
  href: string, // To disable the link, pass in empty string ''
  disabled?: boolean, // If true, this will set @props.href = '' and (css) cursor: default
  id?: string | number,
  afterClick?: ?() => void,
  className?: string,
  children: Node,
  style?: Object,
};

export default class Link extends React.PureComponent<Props> {
  static defaultProps = {
      disabled: false,
      id: undefined,
      className: undefined,
  };

  render() {
      return (
          <ReactRouterLink
              className={classNames(this.props.className, { disabled: this.props.disabled })}
              id={this.props.id}
              to={this.props.href}
              onClick={this.props.afterClick}
              style={this.props.style}
          >
              {this.props.children}
          </ReactRouterLink>
      );
  }
}
